import { Injectable } from "@angular/core";
import { AppConfig } from "src/app/shared/config";
@Injectable({
  providedIn: "root",
})
export class AnalyticsService {
  constructor() { }
  
 getEnv(){
    if(location.hostname.includes('digitalclaims.aig.com')){
      return 'PROD';
    } else  if(location.hostname.includes('uat.digitalclaims.nprd.aig.com')){
      return 'UAT';
    } else  if(location.hostname.includes('qa.digitalclaims.nprd.aig.com')){
      return 'QA';
    } else  if(location.hostname.includes('dev.digitalclaims.nprd.aig.com')){
      return 'DEV';
    } 
  }
   enableSplunk( claimNumber) {
    const env=this.getEnv();
    try {
      const token = AppConfig['rumAccessToken'];

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "splunkRum";
      script.innerText = ` SplunkRum.init({
          realm: 'us0',
          rumAccessToken: '` + token + `',
          applicationName: "5353-CDP-LITE",
          version: "1.0.0",
          deploymentEnvironment: '` + env + `',
          globalAttributes: {
            'userId' : ` + JSON.stringify(claimNumber) + `,
          }
          });
          SplunkSessionRecorder.init({
            realm: 'us0',
            rumAccessToken: '` + token + `' 
          });`;
      document.head.appendChild(script);
    } catch (err) {
      console.log("Splunk initialization error", err);
    }
  }
  addAnalyticsURL(): void | Promise<any> {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.async = true;
      const url= AppConfig[`analyticsURL`];
      script.setAttribute('src',url)
    //  script.src = AppConfig[`${lang}AnalyticsURL`];
      script.type = "text/javascript";
      script.addEventListener("load", resolve);
      script.addEventListener("error", () => reject("Error loading script"));
      script.addEventListener("abort", () => reject("Script load aborted"));
      document.head.appendChild(script);
    });
  }
}

